<script lang="ts">
	import type { SanityPicture } from "./types/Sanity";
	import Picture from "./Picture.svelte";
	import type { ClassValue } from "svelte/elements";

	interface Props {
		class?: ClassValue;
		pictureObject?: SanityPicture;
		circle?: boolean;
		/** Falls back to the picture object's own alt. Pass `""` to mark the
		 *  image decorative — the fallback is skipped only for an explicit `""`. */
		alt?: string;
		// HTML Picture sizes property -- the width of the image in the DOM
		sizes?: string | null;
		// loading is "lazy" by default, but above the fold images can be "eager"
		loading?: "eager" | "lazy";
		// fetchpriority "high" on the LCP image
		fetchpriority?: "high" | "low" | "auto";
		// decoding should rarely be anything other than "async"
		decoding?: "async" | "auto" | "sync" | null;
		// width, height
		width?: number | null;
		height?: number | null;
	}

	let {
		class: classes = "",
		pictureObject,
		circle = false,
		alt = undefined,
		sizes = null,
		loading = "lazy",
		fetchpriority = undefined,
		decoding = null,
		width = null,
		height = null,
	}: Props = $props();

	let widthValue = $derived(
		width || pictureObject?.width || pictureObject?.asset?.metadata?.dimensions?.width
	);
	let heightValue = $derived(
		height || pictureObject?.height || pictureObject?.asset?.metadata?.dimensions?.height
	);
</script>

{#if pictureObject?.src}
	<Picture
		src={pictureObject.src}
		srcset={pictureObject.srcset}
		srcsetWebp={pictureObject.srcsetWebp}
		alt={alt ?? pictureObject.alt ?? ""}
		width={widthValue}
		height={heightValue}
		{sizes}
		{loading}
		{fetchpriority}
		{decoding}
		{circle}
		class={classes}
	/>
{/if}
